import { Title } from '../../atoms/title/Title';
import { Grid } from '@mui/material';
import logo from '../../../assets/eemdl-logo.png';
import { modelSettings } from '../../../settings/settings';

export const Header = ({ modelName }: { modelName: string }) => {
  const currentModelSettings = modelSettings[modelName];
  return (
    <Grid
      container
      spacing={3}
      padding={2}
      alignItems={'top'}
      justifyItems={'center'}
    >
      <Grid item xs={2} sm={2}>
        <img
          src={logo}
          alt="logo"
          style={{ maxWidth: '200px', marginTop: '5px' }}
          width={'100%'}
        />
      </Grid>
      <Grid item xs={10} sm={10} alignItems={'top'}>
        <Title title={currentModelSettings.title} />
      </Grid>
      <Grid item xs={12} sm={12}>
        <div
          dangerouslySetInnerHTML={{
            __html: currentModelSettings.description || '',
          }}
        />
      </Grid>
    </Grid>
  );
};
